/* eslint-disable @typescript-eslint/no-explicit-any */
export const arrangementOptions = [
    {
        value: 'above',
        label: 'above',
    },
    {
        value: 'below',
        label: 'below',
    },
    {
        value: 'opposite',
        label: 'opposite',
    },
    {
        value: 'adjacent to',
        label: 'adjacent to',
    },
    {
        value: 'remote from',
        label: 'remote from',
    },
    {
        value: 'spaced from',
        label: 'spaced from',
    },
    {
        value: 'spaced in an axial direction from',
        label: 'spaced in an axial direction from',
    },
    {
        value: 'spaced in a radial direction from',
        label: 'spaced in a radial direction from',
    },
    {
        value: 'spaced in a circumferential direction from',
        label: 'spaced in a circumferential direction from',
    },
    {
        value: 'inside',
        label: 'inside',
    },
    {
        value: 'outside',
        label: 'outside',
    },
    {
        value: 'surrounding',
        label: 'surrounding',
    },
    {
        value: 'enclosed by',
        label: 'enclosed by',
    },
    {
        value: 'concentric',
        label: 'concentric',
    },
    {
        value: 'coaxial',
        label: 'coaxial',
    },
    {
        value: 'coterminous',
        label: 'coterminous',
    },
]
